const a3PaySetupEn: Record<string, string> = {
  "a3PaySetup.receiptTemplates.approval": "Approval",
  "a3PaySetup.receiptTemplates.approvalId": "Approval ID",
  "a3PaySetup.receiptTemplates.reviewApproval": "Review request",
  "a3PaySetup.receiptTemplates.approve": "Approve",
  "a3PaySetup.receiptTemplates.approvalRequested": "Approval requested. A different operator must approve it; then repeat the action.",

  "a3PaySetup.receiptTemplates.samplePreview": "Example preview only. Nothing is charged or sent. Enter a payment reference to preview an actual receipt.",
  "a3PaySetup.receiptTemplates.saveBeforePreview": "Save the draft to preview it.",
  "a3PaySetup.receiptTemplates.messageType": "Message",
  "a3PaySetup.receiptTemplates.purchase": "Purchase receipt",
  "a3PaySetup.receiptTemplates.scheduled": "Visit and purchase receipt",

  "a3PaySetup.a11y.paymentAccountSummary": "Payment account summary",
  "a3PaySetup.a11y.providersAndMethods": "Providers and payment methods",
  "a3PaySetup.a11y.headerActions": "Payment account actions",
  "a3PaySetup.a11y.stickyNextAction": "Next setup action",
  "a3PaySetup.actions.activate": "Activate",
  "a3PaySetup.actions.apply": "Apply",
  "a3PaySetup.actions.check": "Check",
  "a3PaySetup.actions.configureMethods": "Configure methods",
  "a3PaySetup.actions.connectProvider": "Connect provider",
  "a3PaySetup.actions.continueSetup": "Continue setup",
  "a3PaySetup.actions.deletePreference": "Delete preference",
  "a3PaySetup.actions.load": "Load",
  "a3PaySetup.actions.manageReceiptSettings": "Manage receipt settings",
  "a3PaySetup.actions.moreActions": "More actions",
  "a3PaySetup.actions.notMine": "Not mine",
  "a3PaySetup.actions.openDisputes": "Open disputes",
  "a3PaySetup.actions.openExport": "Open export",
  "a3PaySetup.actions.openPayments": "Open payments",
  "a3PaySetup.actions.openPayouts": "Open payouts",
  "a3PaySetup.actions.openReceipts": "Open receipts",
  "a3PaySetup.actions.openReconciliation": "Open matching issues",
  "a3PaySetup.actions.openRefunds": "Open refunds",
  "a3PaySetup.actions.refresh": "Refresh",
  "a3PaySetup.actions.rollback": "Rollback",
  "a3PaySetup.actions.save": "Save",
  "a3PaySetup.actions.saveDraft": "Save draft",
  "a3PaySetup.actions.send": "Send",
  "a3PaySetup.actions.setProviderAccount": "Set provider account",
  "a3PaySetup.actions.showTechnicalDetails": "Show technical details",
  "a3PaySetup.actions.testTableServicePayment": "Test Table Service payment",
  "a3PaySetup.actions.trace": "Trace",
  "a3PaySetup.actions.updateAccountData": "Update account data",
  "a3PaySetup.common.a3Pay": "A3 Pay",
  "a3PaySetup.common.accountConnected": "Account connected",
  "a3PaySetup.common.accountNotConnected": "Not connected",
  "a3PaySetup.common.actionNeeded": "Action needed",
  "a3PaySetup.common.amount": "Amount",
  "a3PaySetup.common.available": "Available",
  "a3PaySetup.common.blocked": "Blocked",
  "a3PaySetup.common.canChangeData": "Can change data",
  "a3PaySetup.common.channel": "Channel",
  "a3PaySetup.common.checking": "Checking",
  "a3PaySetup.common.currency": "Currency",
  "a3PaySetup.common.deleted": "Deleted",
  "a3PaySetup.common.email": "Email",
  "a3PaySetup.common.enabled": "Enabled",
  "a3PaySetup.common.inProgress": "In progress",
  "a3PaySetup.common.loadingSettings": "Loading settings",
  "a3PaySetup.common.merchant": "Merchant",
  "a3PaySetup.common.notCompleted": "Not completed",
  "a3PaySetup.common.notRecordedYet": "Not recorded yet",
  "a3PaySetup.common.off": "Off",
  "a3PaySetup.common.optional": "optional",
  "a3PaySetup.common.order": "Order",
  "a3PaySetup.common.paid": "Paid",
  "a3PaySetup.common.paymentReference": "Payment reference",
  "a3PaySetup.common.privateLink": "Private link",
  "a3PaySetup.common.productConsole": "Product console",
  "a3PaySetup.common.readOnly": "Read-only",
  "a3PaySetup.common.ready": "Ready",
  "a3PaySetup.common.receiptSettings": "Receipt settings",
  "a3PaySetup.common.recentlyUpdated": "Recently updated",
  "a3PaySetup.common.reference": "Reference",
  "a3PaySetup.common.secureCheckout": "Secure checkout",
  "a3PaySetup.common.status": "Status",
  "a3PaySetup.common.updated": "Updated",
  "a3PaySetup.common.updatedAt": "Updated {value}",
  "a3PaySetup.common.version": "Version",
  "a3PaySetup.dates.notUpdatedYet": "Not updated yet",
  "a3PaySetup.diagnostics.evidenceExport.description": "Export payment requests, events, payout instructions, protected funds records, payouts, review cases and terminal evidence.",
  "a3PaySetup.diagnostics.evidenceExport.title": "Evidence export",
  "a3PaySetup.diagnostics.rawStatusDetails": "Raw status details",
  "a3PaySetup.errors.loadPaymentAccounts": "Unable to load payment account status",
  "a3PaySetup.errors.loadMerchantReadiness": "Unable to load merchant readiness",
  "a3PaySetup.errors.loadProductionReadiness": "Failed to load production readiness",
  "a3PaySetup.errors.loadRegistry": "Unable to load Core Registry records",
  "a3PaySetup.errors.merchantRequired": "Merchant is required.",
  "a3PaySetup.errors.loadReceiptPreference": "This receipt settings link is no longer available.",
  "a3PaySetup.errors.loadTemplates": "Unable to load templates",
  "a3PaySetup.errors.loadTrace": "Unable to load A3 Pay trace",
  "a3PaySetup.errors.paymentAccountRetry": "Payment account status needs another try",
  "a3PaySetup.errors.paymentNotFound": "Payment was not found.",
  "a3PaySetup.errors.paymentStatusUnavailable": "Payment status is temporarily unavailable.",
  "a3PaySetup.errors.productionReadinessFailed": "Readiness status failed",
  "a3PaySetup.errors.receiptCouldNotSend": "Receipt could not be sent right now.",
  "a3PaySetup.errors.receiptPreferenceDeletedFailed": "Receipt settings could not be deleted right now.",
  "a3PaySetup.errors.receiptPreferenceSaveFailed": "Receipt settings could not be saved right now.",
  "a3PaySetup.errors.receiptPreferenceUpdateFailed": "Receipt settings could not be updated right now.",
  "a3PaySetup.errors.registryFailed": "Registry action failed",
  "a3PaySetup.errors.saveProviderAccount": "Unable to save provider account",
  "a3PaySetup.errors.saveRegistry": "Unable to save Core Registry record",
  "a3PaySetup.errors.saveTemplate": "Unable to save template",
  "a3PaySetup.errors.technicalMessage": "Technical message",
  "a3PaySetup.errors.technicalTimestamp": "Timestamp",
  "a3PaySetup.errors.templateMerchantRequired": "Merchant reference is required.",
  "a3PaySetup.errors.traceRetry": "Trace needs another try",
  "a3PaySetup.errors.tryAgainBody": "Try again. If this keeps happening, contact support. Technical details are hidden below.",
  "a3PaySetup.errors.updateAccountData": "Unable to update payment account data",
  "a3PaySetup.forms.changeEmail": "Change email",
  "a3PaySetup.forms.directoryMerchant": "Directory merchant",
  "a3PaySetup.forms.directoryRef": "Directory ref",
  "a3PaySetup.forms.enableA3Pay": "Enable A3 Pay",
  "a3PaySetup.forms.enterPaymentReference": "Enter payment reference",
  "a3PaySetup.forms.html": "HTML",
  "a3PaySetup.forms.locale": "Locale",
  "a3PaySetup.forms.merchantRef": "Merchant ref",
  "a3PaySetup.forms.merchantIdPlaceholder": "merchant id",
  "a3PaySetup.forms.optionalPlaceholder": "optional",
  "a3PaySetup.forms.paymentProviderAccount": "Provider account",
  "a3PaySetup.forms.providerAccountPlaceholder": "acct_...",
  "a3PaySetup.forms.paymentReferencePlaceholder": "payment id, idempotency key, provider payment id",
  "a3PaySetup.forms.paymentRequestRef": "Payment request ref",
  "a3PaySetup.forms.replyTo": "Reply-to",
  "a3PaySetup.forms.senderEmail": "Sender email",
  "a3PaySetup.forms.senderName": "Sender name",
  "a3PaySetup.forms.sourceMerchantRef": "Merchant ref",
  "a3PaySetup.forms.subject": "Subject",
  "a3PaySetup.forms.text": "Text",
  "a3PaySetup.header.navigationLabel": "{productName} navigation",
  "a3PaySetup.header.payTagline": "Registered PI online payment operations",
  "a3PaySetup.nav.acceptance": "Payment acceptance",
  "a3PaySetup.nav.accounts": "Accounts",
  "a3PaySetup.nav.acquirer": "Terminal settlement",
  "a3PaySetup.nav.disputes": "Disputes",
  "a3PaySetup.nav.evidence": "Evidence",
  "a3PaySetup.nav.merchants": "Merchants",
  "a3PaySetup.nav.operations": "Operations",
  "a3PaySetup.nav.payments": "Payments",
  "a3PaySetup.nav.readiness": "Readiness",
  "a3PaySetup.nav.receiptEmails": "Receipt emails",
  "a3PaySetup.nav.receipts": "Receipts",
  "a3PaySetup.nav.reconciliation": "Payment matching",
  "a3PaySetup.nav.registry": "Registry",
  "a3PaySetup.nav.remittance": "Payouts",
  "a3PaySetup.nav.risk": "Risk",
  "a3PaySetup.nav.riskDisputes": "Risk and disputes",
  "a3PaySetup.nav.safeguarding": "Protected funds",
  "a3PaySetup.nav.safeguardingReconciliation": "Safeguarding and reconciliation",
  "a3PaySetup.nav.settlementRemittance": "Settlement and remittance",
  "a3PaySetup.nav.supportDiagnostics": "Support diagnostics",
  "a3PaySetup.nav.trace": "Trace",
  "a3PaySetup.notices.accountDataRefreshed": "Account data refreshed",
  "a3PaySetup.notices.paymentAccountDataAlreadyCurrent": "Payment account data is already up to date.",
  "a3PaySetup.notices.paymentAccountDataUpdated_one": "Payment account data updated for {count} record.",
  "a3PaySetup.notices.paymentAccountDataUpdated_other": "Payment account data updated for {count} records.",
  "a3PaySetup.notices.providerAccountSavedEnabled": "Provider account saved in A3 Pay and enabled for selected checkout.",
  "a3PaySetup.notices.providerAccountSavedShared": "Provider account saved in A3 Pay for shared payment setup.",
  "a3PaySetup.notices.receiptAutomaticOff": "Automatic receipts have been turned off.",
  "a3PaySetup.notices.receiptAlreadyRequested": "This receipt has already been requested. No duplicate email was sent.",
  "a3PaySetup.notices.receiptEmailQueued": "Receipt email queued.",
  "a3PaySetup.notices.receiptFiscalPending": "Payment is complete. The fiscal receipt is still being prepared, so email delivery will wait.",
  "a3PaySetup.notices.receiptPreferenceDeleted": "This receipt preference has been deleted.",
  "a3PaySetup.notices.receiptSettingsSaved": "Receipt settings saved.",
  "a3PaySetup.notices.receiptTryLater": "Receipt email was requested recently. Try again later if it has not arrived.",
  "a3PaySetup.notices.receiptsAvailableAfterPayment": "Receipt is available after payment is complete.",
  "a3PaySetup.notices.validEmailRequired": "Enter a valid email if you want a receipt by email.",
  "a3PaySetup.merchantReadiness.blockingLabel": "Blocking",
  "a3PaySetup.merchantReadiness.blockingWarnings": "{blocking} blocked, {warnings} warning",
  "a3PaySetup.merchantReadiness.cards.gates": "Readiness gates",
  "a3PaySetup.merchantReadiness.cards.merchant": "Merchant",
  "a3PaySetup.merchantReadiness.cards.onlinePayments": "Online payments",
  "a3PaySetup.merchantReadiness.cards.owner": "Owning Party",
  "a3PaySetup.merchantReadiness.description": "Merchant readiness is resolved from Core Registry and A3 Pay evidence, not from raw provider or directory refs.",
  "a3PaySetup.merchantReadiness.emptyProvider": "No Stripe or Klix provider account is active for this merchant.",
  "a3PaySetup.merchantReadiness.emptyRecipients": "No settlement recipients or finance roles are linked yet.",
  "a3PaySetup.merchantReadiness.eyebrow": "Merchant readiness",
  "a3PaySetup.merchantReadiness.gatesDescription": "Missing items are grouped by accountable owner.",
  "a3PaySetup.merchantReadiness.operations.lastFailed": "Last failed payment",
  "a3PaySetup.merchantReadiness.operations.lastSuccessful": "Last successful payment",
  "a3PaySetup.merchantReadiness.operations.openDisputes": "Open disputes",
  "a3PaySetup.merchantReadiness.operations.openHolds": "Open holds",
  "a3PaySetup.merchantReadiness.operations.riskCases": "Open risk cases",
  "a3PaySetup.merchantReadiness.paymentStatus.disabled": "Disabled",
  "a3PaySetup.merchantReadiness.paymentStatus.held": "Held",
  "a3PaySetup.merchantReadiness.paymentStatus.live": "Live",
  "a3PaySetup.merchantReadiness.paymentStatus.pending_review": "Pending review",
  "a3PaySetup.merchantReadiness.paymentStatus.sandbox": "Sandbox",
  "a3PaySetup.merchantReadiness.paymentStatus.suspended": "Suspended",
  "a3PaySetup.merchantReadiness.warningsLabel": "Warnings",
  "a3PaySetup.merchantReadiness.scope.latvia": "Latvia-linked",
  "a3PaySetup.merchantReadiness.scope.noWallet": "No wallet or e-money",
  "a3PaySetup.merchantReadiness.scope.onlineOnly": "Online-only",
  "a3PaySetup.merchantReadiness.scope.volume": "Monthly volume",
  "a3PaySetup.merchantReadiness.sections.eventContext": "Event context",
  "a3PaySetup.merchantReadiness.sections.missing": "Missing actions",
  "a3PaySetup.merchantReadiness.sections.missingDescription": "Actionable gaps grouped by accountable owner.",
  "a3PaySetup.merchantReadiness.sections.operations": "Operations",
  "a3PaySetup.merchantReadiness.sections.provider": "Provider adapter",
  "a3PaySetup.merchantReadiness.sections.providerDescription": "Provider internals stay in Support diagnostics; this page shows readiness only.",
  "a3PaySetup.merchantReadiness.sections.recipients": "Settlement recipients",
  "a3PaySetup.merchantReadiness.sections.recipientsDescription": "MerchantParty roles that may receive remittances or operate finance workflows.",
  "a3PaySetup.merchantReadiness.sections.scope": "Registered PI scope",
  "a3PaySetup.merchantReadiness.title": "Merchant readiness",
  "a3PaySetup.merchantReadiness.noMissing": "No missing actions.",
  "a3PaySetup.registry.actions.archive": "Archive",
  "a3PaySetup.registry.actions.cancelEdit": "Cancel edit",
  "a3PaySetup.registry.actions.createRecord": "Create record",
  "a3PaySetup.registry.actions.delete": "Delete",
  "a3PaySetup.registry.actions.disable": "Disable",
  "a3PaySetup.registry.actions.edit": "Edit",
  "a3PaySetup.registry.actions.editRecord": "Edit record",
  "a3PaySetup.registry.actions.exportSnapshot": "Export snapshot",
  "a3PaySetup.registry.actions.openReadiness": "Readiness",
  "a3PaySetup.registry.actions.restore": "Restore",
  "a3PaySetup.registry.actions.showDeleted": "Show deleted records",
  "a3PaySetup.registry.description": "Review, edit, delete, restore and export payment-relevant Core Registry records.",
  "a3PaySetup.registry.empty": "No records in this view yet.",
  "a3PaySetup.registry.eyebrow": "Core Registry Admin",
  "a3PaySetup.registry.formDescription": "Structured writes go through Core Registry directory contracts with version and audit evidence.",
  "a3PaySetup.registry.forms.country": "Country",
  "a3PaySetup.registry.forms.currency": "Currency",
  "a3PaySetup.registry.forms.displayName": "Display name",
  "a3PaySetup.registry.forms.legalStatus": "Legal status",
  "a3PaySetup.registry.forms.methodProfile": "Method profile",
  "a3PaySetup.registry.forms.ownerParty": "Owning Party",
  "a3PaySetup.registry.forms.party": "Party",
  "a3PaySetup.registry.forms.partyOptional": "Party (optional)",
  "a3PaySetup.registry.forms.partyType": "Party type",
  "a3PaySetup.registry.forms.payoutEvidence": "Payout evidence",
  "a3PaySetup.registry.forms.phone": "Phone",
  "a3PaySetup.registry.forms.product": "Product entitlement",
  "a3PaySetup.registry.forms.provider": "Provider",
  "a3PaySetup.registry.forms.providerPath": "Provider path",
  "a3PaySetup.registry.forms.registeredAddress": "Registered address",
  "a3PaySetup.registry.forms.registeredNumber": "Registered number",
  "a3PaySetup.registry.forms.role": "Role",
  "a3PaySetup.registry.forms.safeAccountRef": "Safe account ref",
  "a3PaySetup.registry.forms.scope": "Scope",
  "a3PaySetup.registry.forms.scopeRecord": "Scope record",
  "a3PaySetup.registry.forms.selectMerchant": "Select merchant",
  "a3PaySetup.registry.forms.selectParty": "Select Party",
  "a3PaySetup.registry.forms.selectScope": "Select scope record",
  "a3PaySetup.registry.forms.timezone": "Timezone",
  "a3PaySetup.registry.listDescription": "Status, source, version and last sync are visible for licensing evidence.",
  "a3PaySetup.registry.notices.archive": "Record archived.",
  "a3PaySetup.registry.notices.created": "Record created.",
  "a3PaySetup.registry.notices.delete": "Record deleted where possible, otherwise archived.",
  "a3PaySetup.registry.notices.deletedRecoverable": "Record moved to deleted records. Enable \"Show deleted records\" to restore it.",
  "a3PaySetup.registry.notices.disable": "Record disabled.",
  "a3PaySetup.registry.notices.restored": "Record restored.",
  "a3PaySetup.registry.notices.snapshotReady": "Registry snapshot prepared with {count} records.",
  "a3PaySetup.registry.notices.updated": "Record updated.",
  "a3PaySetup.registry.ownerLinked": "Owner linked",
  "a3PaySetup.registry.ownerMissing": "Owner missing",
  "a3PaySetup.registry.safeRefMissing": "Safe ref missing",
  "a3PaySetup.registry.safeRefRecorded": "Safe ref recorded",
  "a3PaySetup.registry.tabs.access": "Access",
  "a3PaySetup.registry.tabs.accounts": "Accounts",
  "a3PaySetup.registry.tabs.entitlements": "Entitlements",
  "a3PaySetup.registry.tabs.memberships": "Memberships",
  "a3PaySetup.registry.tabs.merchants": "Merchants",
  "a3PaySetup.registry.tabs.parties": "Parties",
  "a3PaySetup.registry.title": "A3 Pay Registry",
  "a3PaySetup.operations.header.description": "Payments, protected funds, reviews and payment matching workspace.",
  "a3PaySetup.operations.header.title": "A3 Pay operations",
  "a3PaySetup.operations.disputes.description_one": "{count} dispute needs attention.",
  "a3PaySetup.operations.disputes.description_other": "{count} disputes need attention.",
  "a3PaySetup.operations.disputes.title": "Disputes",
  "a3PaySetup.operations.payments.description_one": "{count} payment hold needs review.",
  "a3PaySetup.operations.payments.description_other": "{count} payment holds need review.",
  "a3PaySetup.operations.payments.title": "Recent payments",
  "a3PaySetup.operations.payouts.description": "Available balance and next payout status.",
  "a3PaySetup.operations.payouts.title": "Payouts",
  "a3PaySetup.operations.reconciliation.description_one": "{count} payment matching issue needs review.",
  "a3PaySetup.operations.reconciliation.description_other": "{count} payment matching issues need review.",
  "a3PaySetup.operations.reconciliation.title": "Payment matching issues",
  "a3PaySetup.operations.refunds.description": "Refund requests and refund history where allowed.",
  "a3PaySetup.operations.refunds.title": "Refunds",
  "a3PaySetup.operations.serviceAlerts.description_one": "{count} service alert needs attention.",
  "a3PaySetup.operations.serviceAlerts.description_other": "{count} service alerts need attention.",
  "a3PaySetup.operations.serviceAlerts.title": "Service alerts",
  "a3PaySetup.operations.summary.heldPayouts": "Held payouts",
  "a3PaySetup.operations.summary.matchingIssues": "Matching issues",
  "a3PaySetup.operations.summary.openDisputes": "Open disputes",
  "a3PaySetup.operations.summary.openReviews": "Open reviews",
  "a3PaySetup.operations.summary.paymentHolds": "Payment holds",
  "a3PaySetup.operations.summary.totalReviews": "Total reviews",
  "a3PaySetup.operations.tabs.acquirer": "Terminal settlement",
  "a3PaySetup.operations.tabs.disputes": "Disputes",
  "a3PaySetup.operations.tabs.ledger": "Protected funds",
  "a3PaySetup.operations.tabs.reconciliation": "Payment matching",
  "a3PaySetup.operations.tabs.remittance": "Payouts",
  "a3PaySetup.operations.tabs.risk": "Reviews",
  "a3PaySetup.paymentAccounts.accountCard.a3PayCheckout": "A3 Pay checkout",
  "a3PaySetup.paymentAccounts.accountCard.a3PayNeedsSetup": "A3 Pay needs setup",
  "a3PaySetup.paymentAccounts.accountCard.a3PayNotEnabled": "A3 Pay not enabled",
  "a3PaySetup.paymentAccounts.accountCard.a3PayReady": "A3 Pay ready",
  "a3PaySetup.paymentAccounts.accountCard.directTableServicePayments": "Direct Table Service payments",
  "a3PaySetup.paymentAccounts.accountCard.merchantPaymentSetup": "Merchant payment setup",
  "a3PaySetup.paymentAccounts.accountCard.klixNotConnected": "Klix not connected",
  "a3PaySetup.paymentAccounts.accountCard.klixReady": "Klix ready",
  "a3PaySetup.paymentAccounts.accountCard.liveReady": "Live ready",
  "a3PaySetup.paymentAccounts.accountCard.noProviderAccount": "No provider account has been imported for this merchant yet.",
  "a3PaySetup.paymentAccounts.accountCard.paymentAccount": "Payment account",
  "a3PaySetup.paymentAccounts.accountCard.stripeDirectNotConnected": "Stripe direct not connected",
  "a3PaySetup.paymentAccounts.accountCard.stripeDirectReady": "Stripe direct ready",
  "a3PaySetup.paymentAccounts.accountStatus.readyForA3Pay": "Ready for A3 Pay",
  "a3PaySetup.paymentAccounts.accountStatus.sandboxCheckoutReady": "Sandbox checkout ready",
  "a3PaySetup.paymentAccounts.accountStatus.stripeDirectAvailable": "Stripe direct available",
  "a3PaySetup.paymentAccounts.capability.cardPresentEvidence": "Terminal/card-present via licensed acquirer",
  "a3PaySetup.paymentAccounts.capability.bnpl": "Pay Later / BNPL",
  "a3PaySetup.paymentAccounts.capability.disputes": "Disputes",
  "a3PaySetup.paymentAccounts.capability.hostedCheckout": "Hosted checkout",
  "a3PaySetup.paymentAccounts.capability.latviaBankPis": "Latvia-linked bank/PIS",
  "a3PaySetup.paymentAccounts.capability.methodWhitelist": "Method whitelist required",
  "a3PaySetup.paymentAccounts.capability.onlineCard": "Online card",
  "a3PaySetup.paymentAccounts.capability.reconciliationFiles": "Reconciliation files",
  "a3PaySetup.paymentAccounts.capability.refunds": "Refunds",
  "a3PaySetup.paymentAccounts.capability.transfers": "Transfers",
  "a3PaySetup.paymentAccounts.capability.wallets": "Wallets",
  "a3PaySetup.paymentAccounts.channels.description": "Live channels stay merchant and evidence scoped.",
  "a3PaySetup.paymentAccounts.channels.needsProvider": "Needs provider",
  "a3PaySetup.paymentAccounts.channels.offPendingSignoff": "Off pending signoff",
  "a3PaySetup.paymentAccounts.channels.title": "Channels",
  "a3PaySetup.paymentAccounts.configure.adapterKlix": "Adapter: Klix hosted purchase with Latvia bank/PIS whitelist",
  "a3PaySetup.paymentAccounts.configure.adapterStripe": "Adapter: Stripe online payments",
  "a3PaySetup.paymentAccounts.configure.description": "A3 Pay owns hosted provider selection for Table Service. Stripe and Klix are configured here; raw refs stay in diagnostics.",
  "a3PaySetup.paymentAccounts.configure.findMerchant": "Find merchant",
  "a3PaySetup.paymentAccounts.configure.findMerchantPlaceholder": "Search by venue, country, currency or status",
  "a3PaySetup.paymentAccounts.configure.klixMethodProfile": "Klix method profile: Latvia bank/PIS only",
  "a3PaySetup.paymentAccounts.configure.klixMethodProfileDescription": "Card, wallet, Pay Later/BNPL and non-approved cross-border methods stay disabled until separate approval.",
  "a3PaySetup.paymentAccounts.configure.noMerchantMatches": "No matching merchants",
  "a3PaySetup.paymentAccounts.configure.noProviderAccounts": "No imported {provider} accounts for this merchant",
  "a3PaySetup.paymentAccounts.configure.noStripeAccounts": "No imported Stripe accounts for this merchant",
  "a3PaySetup.paymentAccounts.configure.provider": "Provider",
  "a3PaySetup.paymentAccounts.configure.providerAccount": "Provider account",
  "a3PaySetup.paymentAccounts.configure.providerAccountHint": "Choose an imported provider account or update account data first.",
  "a3PaySetup.paymentAccounts.configure.providerKlix": "Klix",
  "a3PaySetup.paymentAccounts.configure.providerStripe": "Stripe",
  "a3PaySetup.paymentAccounts.configure.selectedProviderAccount": "{account} selected for Table Service payments.",
  "a3PaySetup.paymentAccounts.configure.selectedStripeAccount": "{account} selected for Table Service payments.",
  "a3PaySetup.paymentAccounts.configure.stripeAccount": "Stripe account",
  "a3PaySetup.paymentAccounts.configure.stripeAccountPlaceholder": "acct_...",
  "a3PaySetup.paymentAccounts.configure.title": "Payment acceptance",
  "a3PaySetup.paymentAccounts.empty.description": "Import Product Directory data to show merchant readiness and provider account status here.",
  "a3PaySetup.paymentAccounts.empty.title": "No payment accounts imported yet",
  "a3PaySetup.paymentAccounts.header.badge": "Multi-merchant payment setup",
  "a3PaySetup.paymentAccounts.header.description": "See which merchants can take A3 Pay payments and which venues can keep using Stripe direct through Table Service.",
  "a3PaySetup.paymentAccounts.header.title": "Payment accounts",
  "a3PaySetup.paymentAccounts.loadedCount": "{count} loaded",
  "a3PaySetup.paymentAccounts.loading": "Loading payment accounts",
  "a3PaySetup.paymentAccounts.missingSetupTitle": "Some merchants need setup before live A3 Pay checkout",
  "a3PaySetup.paymentAccounts.providers.description": "Provider setup is separate from the payment methods merchants can offer.",
  "a3PaySetup.paymentAccounts.providers.accounts": "{count} accounts",
  "a3PaySetup.paymentAccounts.providers.allowedMethods": "Allowed: {methods}",
  "a3PaySetup.paymentAccounts.providers.disabledMethods": "Disabled: {methods}",
  "a3PaySetup.paymentAccounts.providers.liveReady": "{count} live-ready",
  "a3PaySetup.paymentAccounts.providers.methodProfile": "Method profile",
  "a3PaySetup.paymentAccounts.providers.sandboxReady": "{count} sandbox-ready",
  "a3PaySetup.paymentAccounts.providers.title": "Providers and methods",
  "a3PaySetup.paymentAccounts.readiness.description": "Account status stays merchant-focused so operators can see what is ready without reading provider payloads.",
  "a3PaySetup.paymentAccounts.readiness.title": "Merchant readiness",
  "a3PaySetup.paymentAccounts.status.disabled": "Off",
  "a3PaySetup.paymentAccounts.status.planned": "Planned",
  "a3PaySetup.paymentAccounts.status.ready": "Ready",
  "a3PaySetup.paymentAccounts.status.setupNeeded": "Needs setup",
  "a3PaySetup.paymentAccounts.summary.a3PayReady": "A3 Pay ready",
  "a3PaySetup.paymentAccounts.summary.canCreateSandbox": "{count} can create sandbox sessions",
  "a3PaySetup.paymentAccounts.summary.enabledForA3Pay": "{count} enabled for A3 Pay",
  "a3PaySetup.paymentAccounts.summary.merchants": "Merchants",
  "a3PaySetup.paymentAccounts.summary.needsSetup": "Needs setup",
  "a3PaySetup.paymentAccounts.summary.stripeDirect": "Stripe direct",
  "a3PaySetup.paymentAccounts.summary.updatedAt": "Updated {value}",
  "a3PaySetup.paymentAccounts.summary.withoutA3Pay": "{count} without A3 Pay enabled",
  "a3PaySetup.production.header.description": "Release gates for read-only review, merchant cutover, backups and provider isolation. Merchant-scoped launch without exposing source-system internals.",
  "a3PaySetup.production.header.title": "Production readiness",
  "a3PaySetup.production.evidence.description": "Generate the dated Latvijas Banka package with readiness, registry, role/access and source-system offline demo evidence.",
  "a3PaySetup.production.evidence.generatePackage": "Generate evidence package",
  "a3PaySetup.production.evidence.preLicensingSnapshot": "Pre-licensing readiness snapshot",
  "a3PaySetup.production.evidence.preLicensingSnapshotDetail": "Attachable release gates, runbooks, unsupported channel flags and production counts.",
  "a3PaySetup.production.evidence.registrySnapshot": "Core Registry snapshot",
  "a3PaySetup.production.evidence.roleAccessExport": "Role/access review export",
  "a3PaySetup.production.evidence.roleAccessExportDetail": "Product roles, access changes and maker/checker decisions are bundled.",
  "a3PaySetup.production.evidence.standaloneBundle": "Source-system offline first bundle",
  "a3PaySetup.production.evidence.title": "Licensing evidence",
  "a3PaySetup.production.runtime.actualDatabase": "Actual database",
  "a3PaySetup.production.runtime.databaseBoundaryChecked": "Database boundary checked",
  "a3PaySetup.production.runtime.databaseBoundaryNotChecked": "Database boundary not checked",
  "a3PaySetup.production.runtime.description": "Non-secret release settings",
  "a3PaySetup.production.runtime.expectedDatabase": "Expected database",
  "a3PaySetup.production.runtime.paymentCutover": "Payment cutover",
  "a3PaySetup.production.runtime.restoreEvidence": "Restore evidence",
  "a3PaySetup.production.runtime.settlementCutover": "Payout cutover",
  "a3PaySetup.production.runtime.title": "Runtime",
  "a3PaySetup.production.sections.isolation.description": "A3 Pay can run without source-system internals",
  "a3PaySetup.production.sections.isolation.title": "Isolation",
  "a3PaySetup.production.sections.operations.accounts": "Accounts",
  "a3PaySetup.production.sections.operations.blockedPayments": "Blocked payments",
  "a3PaySetup.production.sections.operations.cutoverRefs": "Cutover refs",
  "a3PaySetup.production.sections.operations.description": "Live evidence behind the decision",
  "a3PaySetup.production.sections.operations.merchants": "Merchants",
  "a3PaySetup.production.sections.operations.openWork": "Open work",
  "a3PaySetup.production.sections.operations.settlementIssues": "Payout issues",
  "a3PaySetup.production.sections.operations.title": "Operations",
  "a3PaySetup.production.sections.releaseGates.description": "Current decision for this A3 Pay rollout scope",
  "a3PaySetup.production.sections.releaseGates.title": "Release gates",
  "a3PaySetup.production.sections.runbooks.approved": "Runbooks approved",
  "a3PaySetup.production.sections.runbooks.description": "Backup, incident, reconciliation, access, continuity and change-notification runbooks are ready before cutover",
  "a3PaySetup.production.sections.runbooks.filesPresent": "{ready}/{total} files present",
  "a3PaySetup.production.sections.runbooks.title": "Runbooks",
  "a3PaySetup.production.sections.scope.channel": "Channel",
  "a3PaySetup.production.sections.scope.description": "Merchant and channel gate context",
  "a3PaySetup.production.sections.scope.directoryMerchant": "Directory merchant",
  "a3PaySetup.production.sections.scope.title": "Scope",
  "a3PaySetup.production.sections.standaloneDemo.description": "Table Service and A3 Pay work with the source system unavailable",
  "a3PaySetup.production.sections.standaloneDemo.evidenceRecorded": "Evidence recorded",
  "a3PaySetup.production.sections.standaloneDemo.latestEvidence": "Latest evidence",
  "a3PaySetup.production.sections.standaloneDemo.latestEvidenceRecorded": "{date} · Evidence recorded",
  "a3PaySetup.production.sections.standaloneDemo.sourceOffline": "Source-system offline payment demo",
  "a3PaySetup.production.sections.standaloneDemo.title": "Standalone demo",
  "a3PaySetup.production.status.blocked": "Blocked",
  "a3PaySetup.production.status.needsReview": "Needs review",
  "a3PaySetup.production.summary.environment": "Environment",
  "a3PaySetup.production.summary.isolation": "Isolation",
  "a3PaySetup.production.summary.onSiteRemittance": "On-site payouts",
  "a3PaySetup.production.summary.providerActions": "Provider actions",
  "a3PaySetup.production.summary.releaseGate": "Release gate",
  "a3PaySetup.production.summary.uiMode": "UI mode",
  "a3PaySetup.receipts.automatic.futureA3Pay": "Send receipts automatically for future A3 Pay payments.",
  "a3PaySetup.receipts.automatic.recognized": "Send receipts automatically when A3 Pay recognizes me.",
  "a3PaySetup.receipts.emailAlreadySaved": "Receipt email is already saved for this payment: {email}",
  "a3PaySetup.receipts.emailOptional": "Email is optional. It is used for this receipt only unless you choose automatic receipts.",
  "a3PaySetup.receipts.emailOptionalNotice": "Email is optional. Add it only if you want a receipt by email.",
  "a3PaySetup.receipts.emailReceipt": "Email receipt",
  "a3PaySetup.receipts.includeMerchantOffers": "Include merchant offers when they are available.",
  "a3PaySetup.receipts.includeMerchantOffersWhenAvailable": "Include merchant-approved offers when available.",
  "a3PaySetup.receipts.paymentCompleteAwaitingFiscal": "Payment is complete. The fiscal receipt is still being prepared, so email delivery will wait.",
  "a3PaySetup.receipts.preferenceEmail": "Receipt email",
  "a3PaySetup.receipts.settingsActionNotMine": "You can stop these receipts below.",
  "a3PaySetup.receipts.settingsActionPromoOptOut": "You can turn off merchant offers below.",
  "a3PaySetup.receiptTemplates.active": "Active",
  "a3PaySetup.receiptTemplates.description": "Merchant sender and locale templates",
  "a3PaySetup.receiptTemplates.from": "From",
  "a3PaySetup.receiptTemplates.noTemplates": "No templates.",
  "a3PaySetup.receiptTemplates.preview": "Preview",
  "a3PaySetup.receiptTemplates.receiptTemplateActivated": "Receipt template activated.",
  "a3PaySetup.receiptTemplates.receiptTemplateRolledBack": "Receipt template rolled back.",
  "a3PaySetup.receiptTemplates.receiptTemplateSaved": "Receipt template saved.",
  "a3PaySetup.receiptTemplates.template": "Template",
  "a3PaySetup.receiptTemplates.title": "Receipt templates",
  "a3PaySetup.sections.diagnostics.description": "For support, finance and compliance troubleshooting. Technical provider, event and evidence refs stay here.",
  "a3PaySetup.sections.diagnostics.title": "Advanced diagnostics",
  "a3PaySetup.sections.evidence.description": "Tablet and desktop view for finance, support and reconciliation checks. Setup remains the primary workflow.",
  "a3PaySetup.sections.evidence.title": "Evidence and reconciliation",
  "a3PaySetup.sections.operations.description": "Daily payment work is separate from first-time setup.",
  "a3PaySetup.sections.operations.title": "Daily payment operations",
  "a3PaySetup.sections.setup.description": "Follow the six checks that decide whether this venue can accept Table Service bill payments.",
  "a3PaySetup.sections.setup.title": "Setup checklist",
  "a3PaySetup.status.available": "Available",
  "a3PaySetup.status.needsReview": "Needs review",
  "a3PaySetup.status.needsSetup": "Needs setup",
  "a3PaySetup.status.ready": "Ready",
  "a3PaySetup.status.underReview": "Under review",
  "a3PaySetup.status.waiting": "Waiting",
  "a3PaySetup.evidence.columns.action": "Action",
  "a3PaySetup.evidence.columns.area": "Area",
  "a3PaySetup.evidence.columns.metric": "Metric",
  "a3PaySetup.evidence.columns.status": "Status",
  "a3PaySetup.evidence.desktopOnly": "Detailed evidence review and export-style actions are available on tablet or desktop.",
  "a3PaySetup.evidence.paymentMatching.detail": "Open reconciliation issues across provider and terminal settlement evidence.",
  "a3PaySetup.evidence.paymentMatching.title": "Payment matching",
  "a3PaySetup.evidence.payoutInstructions.detail": "Held or failed payout intake items.",
  "a3PaySetup.evidence.payoutInstructions.title": "Payout instructions",
  "a3PaySetup.evidence.protectedFunds.detail": "Available protected balance before payout execution.",
  "a3PaySetup.evidence.protectedFunds.title": "Protected funds",
  "a3PaySetup.evidence.providerUpdates.detail": "Payment holds and provider update alerts.",
  "a3PaySetup.evidence.providerUpdates.title": "Provider updates",
  "a3PaySetup.evidence.tableLabel": "Evidence and reconciliation review",
  "a3PaySetup.evidence.terminalSettlement.detail": "Licensed acquirer terminal evidence with open matching breaks.",
  "a3PaySetup.evidence.terminalSettlement.title": "Terminal settlement",
  "a3PaySetup.statusPage.checkingPayment": "Checking payment",
  "a3PaySetup.statusPage.latestUpdate": "Latest event",
  "a3PaySetup.statusPage.merchant": "Merchant",
  "a3PaySetup.statusPage.paymentStatus": "Payment status",
  "a3PaySetup.statusPage.recentUpdates": "Recent updates",
  "a3PaySetup.statusPage.title": "Payment status",
  "a3PaySetup.steps.businessProfile.detail": "Confirm the business profile and venue identity used for payment acceptance.",
  "a3PaySetup.steps.businessProfile.title": "Business profile",
  "a3PaySetup.steps.methods.detail": "Choose the online and terminal/card-present methods guests can use.",
  "a3PaySetup.steps.methods.title": "Payment methods",
  "a3PaySetup.steps.payouts.detail": "Confirm payout status and payment matching before funds are sent.",
  "a3PaySetup.steps.payouts.title": "Payouts and reconciliation",
  "a3PaySetup.steps.provider.detail": "Connect the provider account used to accept guest payments.",
  "a3PaySetup.steps.provider.title": "Payment provider",
  "a3PaySetup.steps.receipts.detail": "Set receipt email behavior and templates where enabled.",
  "a3PaySetup.steps.receipts.title": "Receipts and emails",
  "a3PaySetup.steps.tableService.detail": "Test that A3 Table Service bills can create a guest payment.",
  "a3PaySetup.steps.tableService.title": "Table Service connection",
  "a3PaySetup.summary.description": "Accept online and terminal/card-present payments for Table Service bills.",
  "a3PaySetup.summary.launchState.actionNeeded": "Action needed",
  "a3PaySetup.summary.launchState.checkingSetup": "Checking setup",
  "a3PaySetup.summary.launchState.paymentsPaused": "Payments paused",
  "a3PaySetup.summary.launchState.payoutSetupRequired": "Payout setup required",
  "a3PaySetup.summary.launchState.providerSetupRequired": "Provider setup required",
  "a3PaySetup.summary.launchState.readyForOnlinePayments": "Ready to accept online payments",
  "a3PaySetup.summary.launchState.readyToTest": "Ready to test",
  "a3PaySetup.summary.launchState.serviceIssue": "Service issue",
  "a3PaySetup.summary.launchState.underReview": "Under review",
  "a3PaySetup.summary.nextAction": "Next: {action}",
  "a3PaySetup.summary.nextActionReady": "Payments are ready.",
  "a3PaySetup.summary.progress": "{ready} of {total} steps ready",
  "a3PaySetup.summary.title": "A3 Pay setup",
  "a3PaySetup.diagnostics.providerAccounts.detail": "Provider account raw status and imported account refs.",
  "a3PaySetup.diagnostics.providerAccounts.title": "Provider accounts",
  "a3PaySetup.diagnostics.providerUpdates.detail": "Provider update health and payment event lag.",
  "a3PaySetup.diagnostics.providerUpdates.title": "Provider updates",
  "a3PaySetup.diagnostics.payoutInstructions.detail": "Payout instruction refs, holds and failed payout intake.",
  "a3PaySetup.diagnostics.payoutInstructions.title": "Payout instructions",
  "a3PaySetup.diagnostics.terminalSettlement.detail": "Terminal/card-present evidence from licensed acquirer settlement.",
  "a3PaySetup.diagnostics.terminalSettlement.title": "Terminal settlement",
  "a3PaySetup.trace.availableFunds": "Available funds",
  "a3PaySetup.trace.dailyPayouts": "Daily payouts",
  "a3PaySetup.trace.dailyResiduals": "Daily residuals",
  "a3PaySetup.trace.header.badge": "Operations trace",
  "a3PaySetup.trace.header.description": "Support and finance can follow source formula -> immutable plan -> payout instruction -> payout without opening an external admin.",
  "a3PaySetup.trace.header.title": "Trace payment",
  "a3PaySetup.trace.heldSettlements": "Held settlements",
  "a3PaySetup.trace.immutablePlan.detail": "The plan ref and hash bind recipient amounts to source evidence.",
  "a3PaySetup.trace.immutablePlan.title": "Immutable plan",
  "a3PaySetup.trace.eventEvidence.detail": "Event data is stored as source evidence only; A3 Pay does not own Event distribution rules.",
  "a3PaySetup.trace.eventEvidence.sourceOnly": "Source evidence only",
  "a3PaySetup.trace.eventEvidence.title": "Event evidence",
  "a3PaySetup.trace.eventRef": "Event ref",
  "a3PaySetup.trace.eventSnapshot": "Event snapshot hash",
  "a3PaySetup.trace.fiscalEvidence.detail": "Fiscal refs and artifacts are supplied by A3 Venue Bridge or A3 Fiscal Register.",
  "a3PaySetup.trace.fiscalEvidence.title": "Fiscal evidence",
  "a3PaySetup.trace.fiscalIntent": "Fiscal intent",
  "a3PaySetup.trace.fiscalOwner": "Fiscal owner",
  "a3PaySetup.trace.fiscalRef": "Fiscal ref",
  "a3PaySetup.trace.latestEvent": "Latest event",
  "a3PaySetup.trace.links.paymentAcceptance": "Payment acceptance and providers",
  "a3PaySetup.trace.links.protectedRemittance": "Protected funds payouts",
  "a3PaySetup.trace.links.reconciliationBreaks": "Payment matching issues",
  "a3PaySetup.trace.openBreaks": "Open breaks",
  "a3PaySetup.trace.openReviews": "Open reviews",
  "a3PaySetup.trace.merchantEvidence.detail": "Merchant and owner evidence are shown without exposing raw directory payloads.",
  "a3PaySetup.trace.merchantEvidence.title": "Merchant and owner",
  "a3PaySetup.trace.merchantSnapshot": "Merchant snapshot",
  "a3PaySetup.trace.ownerParty": "Owner Party",
  "a3PaySetup.trace.ownerSnapshot": "Owner snapshot",
  "a3PaySetup.trace.paymentEvents.detail": "Provider status is visible without reading provider payloads.",
  "a3PaySetup.trace.paymentEvents.title": "Payment request and events",
  "a3PaySetup.trace.paymentHolds": "Payment holds",
  "a3PaySetup.trace.paymentStatus": "Payment status",
  "a3PaySetup.trace.planHash": "Plan hash",
  "a3PaySetup.trace.planRef": "Plan ref",
  "a3PaySetup.trace.profileVersion": "Profile version",
  "a3PaySetup.trace.provider": "Provider",
  "a3PaySetup.trace.providerMode": "Provider mode",
  "a3PaySetup.trace.providerSession": "Hosted session",
  "a3PaySetup.trace.queueItems": "Queue items",
  "a3PaySetup.trace.reason": "Reason",
  "a3PaySetup.trace.recipientTotal": "Recipient total",
  "a3PaySetup.trace.relatedPayouts": "Related payouts",
  "a3PaySetup.trace.riskHolds": "Risk holds",
  "a3PaySetup.trace.safeguardedFunds.detail": "Funds are grouped by source credit, merchant and channel.",
  "a3PaySetup.trace.safeguardedFunds.title": "Protected funds",
  "a3PaySetup.trace.sent": "Sent",
  "a3PaySetup.trace.settlementInstruction.created": "Created",
  "a3PaySetup.trace.settlementInstruction.detail": "A3 Pay can accept, hold or reject without editing source rules.",
  "a3PaySetup.trace.settlementInstruction.instruction": "Instruction",
  "a3PaySetup.trace.settlementInstruction.title": "Payout instruction",
  "a3PaySetup.trace.sourceFormula.detail": "The source system owns recipient rules and calculation evidence.",
  "a3PaySetup.trace.sourceFormula.a3PayFormula": "No A3 Pay formula",
  "a3PaySetup.trace.sourceFormula.owner": "Owner",
  "a3PaySetup.trace.sourceFormula.sourceManagedCopy": "Source-managed mode stays owned by the source system. Standalone mode stays managed by A3 Table Service. A3 Pay does not calculate formulas.",
  "a3PaySetup.trace.sourceFormula.sourceRef": "Source ref",
  "a3PaySetup.trace.sourceFormula.title": "Source formula",
  "a3PaySetup.trace.sourceOwner.coopPlatform": "Managed by source platform",
  "a3PaySetup.trace.sourceOwner.notRecorded": "Source system not recorded",
  "a3PaySetup.trace.sourceOwner.tableServiceStandalone": "Managed by A3 Table Service standalone",
  "a3PaySetup.trace.status.needsEvidence": "Needs evidence",
  "a3PaySetup.trace.status.ready": "Ready",
  "a3PaySetup.trace.remittance.detail": "Payouts, holds and payment matching issues are traceable from the same workspace.",
  "a3PaySetup.trace.remittance.title": "Payouts and payment matching",
};

export default a3PaySetupEn;
